import React, { lazy, Suspense } from "react";
import { Snack, Load } from "bnb-ui/dist";

const Home = lazy(() => import("../../pages/Home"));

interface ErrorControlState {
	hasError: boolean;
	hasErrorClosed: boolean;
}

export default class ErrorBoundary extends React.Component<any, ErrorControlState> {
	constructor(props) {
		super(props);
		this.state = { hasError: false, hasErrorClosed: false };
	}

	closeSnack = (): void => {
		this.setState({ hasError: false, hasErrorClosed: true });
		this.props.push("/");
	};

	componentDidCatch(error, info) {
		this.setState({ hasError: true });
	}

	renderLoader = () => {
		return <Load></Load>;
	};
	render() {
		if (this.state.hasError) {
			return (
				<>
					<Suspense fallback={this.renderLoader()}>
						<Home />
						<Snack
							variant="error"
							message="Ocorreu um erro interno na aplicação. Por favor, tente novamente."
							open={this.state.hasError}
							onClose={this.closeSnack}
						/>
					</Suspense>
				</>
			);
		} else {
			return this.props.children;
		}
	}
}
